import { useFeatureFlags } from '@usap/core';

const useIsNewHeaderFlowEnabled = () => {
  const { f109 } = useFeatureFlags();

  const f109Enabled = ['b', '1', 'on', 'true'];

  if (typeof f109 === 'string') {
    if (f109Enabled.includes(f109)) {
      return true;
    }
  }

  return false;
};

export default useIsNewHeaderFlowEnabled;
